module.exports = __webpack_public_path__ + "img/DarojatYogi-nologo.e9873fb9.png";